// extracted by mini-css-extract-plugin
export var ml_button = "Header-module--ml_button--2fee2";
export var model = "Header-module--model--75a9d";
export var productHeader = "Header-module--productHeader--3d5da";
export var productHeader__title = "Header-module--productHeader__title--ed535";
export var product_code = "Header-module--product_code--f156b";
export var title = "Header-module--title--0129f";